import { infuse } from '../../ioc-config';

const {
  srp: { compareFeature },
} = infuse('config');

const is = (what: string) => (value: string) => value === what;

export const isCompareAvailableOn = (page, businessProfile) =>
  Boolean(compareFeature?.find(is(`${page}-${businessProfile}`))?.length);
export const isCompareAvailableAtSomePoint = () => Boolean(compareFeature?.length);
